import store from '../configureStore';
import { apiGet, apiPost } from './apiUtil';

const sendGuestMessage = (hash: string, header: Record<string, string>, message: string) => {
  const init = {
    headers: header,
    body: { msgbody: message },
  };
  return apiPost(`/guest/message/send/${hash}`, init);
};

export const sendMessage = (projectId: string, message: string) => {
  const {
    project: { header, userRole, guestHash },
    workspace: { currentUserGroup },
  } = store.getState();
  if (userRole === 'guest') return sendGuestMessage(guestHash, header, message);
  const sendMessageInit = {
    headers: header,
    body: { project: projectId, msgbody: message },
  };

  return apiPost(`/message/send?gid=${currentUserGroup}`, sendMessageInit);
};

export const notifyProjectParticipants = (projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const sendMessageInit = {
    headers: header,
    // Object body → JSON, matching sendMessage (which works on the same /message/send endpoint).
    // A url-encoded string body would be JSON-stringified into a quoted string and mis-parsed.
    body: { project: projectId, cmd: 'notify' },
  };
  return apiPost(`/message/send?gid=${currentUserGroup}`, sendMessageInit);
};

export const getMessagesByProject = (projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const getMessagesByProjectInit = {
    headers: header,
  };
  return apiGet(
    `/message/project/${projectId}?gid=${currentUserGroup}`,
    getMessagesByProjectInit,
  );
};

export const getMessages = () => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const getMessagesInit = {
    headers: header,
  };
  return apiGet(`/message?gid=${currentUserGroup}`, getMessagesInit);
};

export const deleteMessage = (messageId: string, projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const deleteMessageInit = {
    headers: header,
    body: `id=${messageId}&project=${projectId}`,
  };
  return apiPost(
    `/message/delete?gid=${currentUserGroup}`,
    deleteMessageInit,
  );
};

export const getWorkspacesMessagesAmount = () => {
  const {
    project: { header },
  } = store.getState();
  const getWorkspacesMessagesAmountInit = {
    headers: header,
  };
  return apiGet('/message?type=groups', getWorkspacesMessagesAmountInit);
};
